module.exports = __webpack_public_path__ + "static/media/growbag_shop2.55146d7a.webp";